import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var PlaneSlash = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320h73.8c34.2 0 93.7-28 93.7-64 0-35-59.5-64-93.7-64H397.8L297.2 16.1C291.5 6.2 280.9 0 269.4 0h-56.2c-10.6 0-18.3 10.2-15.4 20.4l40.3 140.9L38.8 5.1zm2.7 123.6C36 130.6 32 135.9 32 142c0 1.3.2 2.6.5 3.9L64 256 32.5 366.1c-.4 1.3-.5 2.6-.5 3.9 0 7.8 6.3 14 14 14h42c5 0 9.8-2.4 12.8-6.4L144 320h102.9l-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4h56.2c11.5 0 22.1-6.2 27.8-16.1l65.3-114.3L41.5 128.7z"
  }));
});
PlaneSlash.displayName = 'PlaneSlash';
export var PlaneSlashDimensions = {
  height: 512,
  width: 640
};